import { FC } from 'react';
import classNames from 'classnames';

import useScrollListener from '~shared/lib/hooks/useScrollListener';
import { useWindowInnerWidth } from '~shared/ui/utils';

import styles from './header.module.scss';

interface HeaderProps {
  children?: React.ReactNode;
}

export const Header: FC<HeaderProps> = ({ children }) => {
  const scroll = useScrollListener();
  const windowWidth = useWindowInnerWidth();

  const headerClass = classNames(
    styles.wrapper,
    windowWidth <= 768 && scroll.y > 150 && scroll.y - scroll.lastY > 0 ? styles.hidden : ''
  );

  return <div className={headerClass}>{children}</div>;
};
